import { network } from '@utils'
import { QueryFunction } from './root'

interface LucaUsageProps {
  slug: string
}

export interface ILucaAllowance {
  plan_credits: number
  addon_credits: number
  manual_credits: number
}

export interface ILucaUsageSnapshot {
  max_credits: number
  used_credits: number
  overage_credits: number
  remaining_credits: number
  usage_percentage: number
  is_over_limit: boolean
  period_start: string
  period_end: string
  allowance: ILucaAllowance
}

export const fetchLucaUsage: QueryFunction<LucaUsageProps, ILucaUsageSnapshot> = async ({
  slug
}) => {
  const url = `/v1/business/${encodeURIComponent(slug)}/luca_usage/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
